// Check if the border is dashed
// borderDash: [5, 5] => dashed
// borderDash: [0, 0] => solid
export const isDashedBorder = borderDash => {
  return Array.isArray(borderDash) && borderDash.every(i => i > 0);
}; // Check if any of the props have been updated

export const checkHasUpdates = props => Boolean(typeof props.width === 'number' || props.style || props.color || props.backgroundColor);